type CategoryDisplayNameSource = {
    id?: string;
    name?: string;
    c_shortnameOverride?: string | null;
};

/**
 * Label for breadcrumbs and PLP subcategory tabs.
 * Prefers `c_shortnameOverride` when set; otherwise category `name`, then `id`.
 */
export function getCategoryDisplayName(category: CategoryDisplayNameSource | null | undefined): string {
    if (!category) {
        return '';
    }
    const override = category.c_shortnameOverride?.trim();
    if (override) {
        return override;
    }
    const name = category.name?.trim();
    if (name) {
        return name;
    }
    return category.id?.trim() || '';
}
